<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-advanced-contact"
      size="xl"
      scrollable
      centered
      button-size="sm"
      @hidden="onReset"
    >
      <template #modal-title>
        <i class="fas fa-user"></i> ADICIONAR CONTATOS AVANÇADOS
      </template>

      <div class="pl-3 pr-3">
        <!-- nome | documento | num. sisbr -->
        <div class="form-group row">
          <div class="col-md-6">
            <label>
              <small
                class="text-danger"
                v-if="form.nomeAssociado.required"
                >*</small
              >
              Nome do Associado:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="'Digite o Nome do Associado'"
                v-model="form.nomeAssociado.value"
                :size="form.nomeAssociado.maxlength"
                :required="form.nomeAssociado.required"
                :state="form.nomeAssociado.state"
              ></b-form-input>
            </div>
          </div>
          <div class="col-md-3">
            <label>
              <small
                class="text-danger"
                v-if="form.document.required"
                >*</small
              >
              Documento:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="'Digite o CPF ou CNPJ'"
                v-model="form.document.value"
                :size="form.document.maxlength"
                :required="form.document.required"
                :state="form.document.state"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              ></b-form-input>
            </div>
          </div>
          <div class="col-md-3">
            <label>
              <small
                class="text-danger"
                v-if="form.numSisbr.required"
                >*</small
              >
              Número SisBR:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="'Digite o Número SisBR'"
                v-model="form.numSisbr.value"
                :size="form.numSisbr.maxlength"
                :required="form.numSisbr.required"
                :state="form.numSisbr.state"
              ></b-form-input>
            </div>
          </div>
        </div>

        <!-- pa | regional | cluster -->
        <div class="form-group row">
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.numeroPA.required"
                >*</small
              >
              PA:
            </label>
            <div class="input-group">
              <v-select
                multiple
                ref="selectPA"
                :closeOnSelect="false"
                :clearSearchOnSelect="false"
                v-model="form.numeroPA.value"
                :options="form.numeroPA.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o PA"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
                <template #list-header>
                  <button
                    class="btn btn-secondary btn-sm btn-block"
                    @click.prevent="handleSelectAllPA"
                  >
                    Selecionar todos
                  </button>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.regionalId.required"
                >*</small
              >
              Regional:
            </label>
            <div class="input-group">
              <v-select
                multiple
                ref="selectRegional"
                :closeOnSelect="false"
                :clearSearchOnSelect="false"
                v-model="form.regionalId.value"
                :options="form.regionalId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione a Regional"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
                <template #list-header>
                  <button
                    class="btn btn-secondary btn-sm btn-block"
                    @click.prevent="handleSelectAllRegional"
                  >
                    Selecionar todos
                  </button>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.clusterizacaoId.required"
                >*</small
              >
              Clusterização:
            </label>
            <div class="input-group">
              <v-select
                multiple
                ref="selectCluster"
                :closeOnSelect="false"
                :clearSearchOnSelect="false"
                v-model="form.clusterizacaoId.value"
                :options="form.clusterizacaoId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o Cluster"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
                <template #list-header>
                  <button
                    class="btn btn-secondary btn-sm btn-block"
                    @click.prevent="handleSelectAllCluster"
                  >
                    Selecionar todos
                  </button>
                </template>
              </v-select>
            </div>
          </div>
        </div>

        <!-- gerente sisbr | agente de relacionamento -->
        <div class="form-group row">
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.gerenteSisbrId.required"
                >*</small
              >
              Gerente SisBR:
            </label>
            <div class="input-group">
              <v-select
                multiple
                ref="selectGerenteSisbr"
                :closeOnSelect="false"
                :clearSearchOnSelect="false"
                v-model="form.gerenteSisbrId.value"
                :options="form.gerenteSisbrId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o Gerente SisBR"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
                <template #list-header>
                  <button
                    class="btn btn-secondary btn-sm btn-block"
                    @click.prevent="handleSelectAllGerenteSisbr"
                  >
                    Selecionar todos
                  </button>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4">
            <label>
              <small
                class="text-danger"
                v-if="form.gerenteRelacionamentoId.required"
                >*</small
              >
              Agente de Relacionamento:
            </label>
            <div class="input-group">
              <v-select
                multiple
                ref="selectGerenteRelacionamento"
                :closeOnSelect="false"
                :clearSearchOnSelect="false"
                v-model="form.gerenteRelacionamentoId.value"
                :options="form.gerenteRelacionamentoId.options"
                :reduce="(x) => x.value"
                class="w-100"
                label="text"
                placeholder="Selecione o Agente de Relacionamento"
              >
                <template v-slot:no-options>{{
                  $lang.Common.PlaceholderSelect
                }}</template>
                <template #list-header>
                  <button
                    class="btn btn-secondary btn-sm btn-block"
                    @click.prevent="handleSelectAllGerenteRelacionamento"
                  >
                    Selecionar todos
                  </button>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-4 mt-4">
            <span
              :class="['btn btn-default btn-outline-dark rounded pointer']"
              style="width: 100%; margin-bottom: 0"
              @click="toggleAdvancedSearch()"
            >
              <i :class="advancedSearch ? 'fas fa-minus' : 'fas fa-plus'"></i>
            </span>
          </div>
        </div>

        <div
          id="BuscaAvancada"
          v-if="advancedSearch"
        >
          <hr />
          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterAssociado === true
                    ? (showFilterAssociado = false)
                    : (showFilterAssociado = true)
                "
              >
                <i
                  v-if="showFilterAssociado"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Associado</label
              >
              <i
                v-if="hasAssociadoFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterAssociado">
            <!-- faixa de data de nascimento | faixa de inicio de relacionamento -->
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-3">
                    <label> Data de Nascimento/Abertura Inicial: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataInicioNascimentoOuAbertura.value"
                      :required="form.dataInicioNascimentoOuAbertura.required"
                      :state="form.dataInicioNascimentoOuAbertura.state"
                    />
                  </div>
                  <div class="col-md-3">
                    <label> Data de Nascimento/Abertura Final: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataFinalNascimentoOuAbertura.value"
                      :required="form.dataFinalNascimentoOuAbertura.required"
                      :state="form.dataFinalNascimentoOuAbertura.state"
                    />
                  </div>

                  <div class="col-md-3">
                    <label> Faixa de Relacionamento Inicial: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataInicialInicioRelacionamento.value"
                      :required="form.dataInicialInicioRelacionamento.required"
                      :state="form.dataInicialInicioRelacionamento.state"
                    />
                  </div>

                  <div class="col-md-3">
                    <label> Faixa de Relacionamento Final: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataFinalInicioRelacionamento.value"
                      :required="form.dataFinalInicioRelacionamento.required"
                      :state="form.dataFinalInicioRelacionamento.state"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- faixa de data de Ult Renovacao -->
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-3">
                    <label> Faixa de Última Renovação Inicial: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataInicialUltimaRenovacao.value"
                      :required="form.dataInicialUltimaRenovacao.required"
                      :state="form.dataInicialUltimaRenovacao.state"
                    />
                  </div>
                  <div class="col-md-3">
                    <label> Faixa de Última Renovação Final: </label>
                    <NxDatePicker
                      :placeholder="$lang.Common.DatePlaceholder"
                      v-model="form.dataFinalUltimaRenovacao.value"
                      :required="form.dataFinalUltimaRenovacao.required"
                      :state="form.dataFinalUltimaRenovacao.state"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- tipo pessoa | pendencias | sexo | estado -->
            <div class="form-group row">
              <div class="col-md-3">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.tipoPessoa.required"
                    >*</small
                  >
                  Tipo Pessoa:
                </label>
                <v-select
                  multiple
                  v-model="form.tipoPessoa.value"
                  :options="form.tipoPessoa.options"
                  :reduce="(x) => x.value"
                  class="w-100"
                  label="text"
                  placeholder="Selecione o Tipo de Pessoa"
                >
                  <template v-slot:no-options>{{
                    $lang.Common.PlaceholderSelect
                  }}</template>
                </v-select>
              </div>
              <div class="col-md-3">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.sexo.required"
                    >*</small
                  >
                  Sexo:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    v-model="form.sexo.value"
                    :options="form.sexo.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o sexo"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.estado.required"
                    >*</small
                  >
                  Estado:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectEstado"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.estado.value"
                    :options="form.estado.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o estado"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllEstado"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.pendencias.required"
                    >*</small
                  >
                  Possíveis Pendências:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectPendencias"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.pendencias.value"
                    :options="form.pendencias.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione a Pendência"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllPendencias"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.naoPossuiPendencias.required"
                    >*</small
                  >
                  Pendências que não possui:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="naoPossuiPendencias"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.naoPossuiPendencias.value"
                    :options="form.naoPossuiPendencias.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione a Pendência"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllnaoPossuiPendencias"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>

            <!-- vinculo empregaticio | descrição da profissao | tipo de renda -->
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.vinculoEmpregaticio.required"
                    >*</small
                  >
                  Vinculo empregatício:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectVinculoEmpregaticio"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.vinculoEmpregaticio.value"
                    :options="form.vinculoEmpregaticio.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o vinculo empregatício"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllVinculoEmpregaticio"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.descricaoProfissao.required"
                    >*</small
                  >
                  Descrição da profissão:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectDescricaoProfissao"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.descricaoProfissao.value"
                    :options="form.descricaoProfissao.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o descrição da profissão"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllDescricaoProfissao"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.isFuncionario.required"
                    >*</small
                  >
                  É Funcionário?
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    v-model="form.isFuncionario.value"
                    :options="form.isFuncionario.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione se é funcionário"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                  </v-select>
                </div>
              </div>
            </div>

            <!-- Tipo de Renda |Faixa de Renda | MEI | produtor rural  -->
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.tipoRenda.required"
                    >*</small
                  >
                  Tipo de Renda:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectTipoRenda"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.tipoRenda.value"
                    :options="form.tipoRenda.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o tipo de renda"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllTipoRenda"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <label> Faixa de Renda:</label>
                <div class="input-group">
                  <money
                    :placeholder="$lang.Currency.Placeholder"
                    class="form-control text-bold"
                    max-length="12"
                    v-model.lazy="rendaInicial"
                    v-bind="$lang.Currency.Format"
                  ></money>
                  <money
                    :placeholder="$lang.Currency.Placeholder"
                    class="form-control text-bold"
                    max-length="12"
                    v-model.lazy="rendaFinal"
                    v-bind="$lang.Currency.Format"
                  ></money>
                </div>
              </div>
              <div class="col-md-2">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.mei.required"
                    >*</small
                  >
                  É MEI:
                </label>
                <div>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.mei.value"
                      aria-describedby="mei"
                      :required="form.mei.required"
                    >
                      <b-form-radio value="true">Sim</b-form-radio>
                      <b-form-radio value="false">Não</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
              </div>
              <div class="col-md-2">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.produtorRural.required"
                    >*</small
                  >
                  É Produtor Rural:
                </label>
                <div>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.produtorRural.value"
                      aria-describedby="produtorRural"
                      :required="form.produtorRural.required"
                    >
                      <b-form-radio value="true">Sim</b-form-radio>
                      <b-form-radio value="false">Não</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
              </div>
            </div>
            <hr />
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterProduto === true
                    ? (showFilterProduto = false)
                    : (showFilterProduto = true)
                "
              >
                <i
                  v-if="showFilterProduto"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Produto</label
              >
              <i
                v-if="hasProdutoFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterProduto">
            <!-- conta corrente | conta capital | IAP que possui -->
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.statusContaCorrente.required"
                    >*</small
                  >
                  Status da Conta Corrente:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectStatusContaCorrente"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.statusContaCorrente.value"
                    :options="form.statusContaCorrente.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o Status da Conta Corrente"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllContaCorrente"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.statusContaCapital.required"
                    >*</small
                  >
                  Status da Conta Capital:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    :closeOnSelect="false"
                    v-model="form.statusContaCapital.value"
                    :options="form.statusContaCapital.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione o Status da Conta Capital"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.iapPossui.required"
                    >*</small
                  >
                  Produtos IAP que possui:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectIap"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.iapPossui.value"
                    :options="form.iapPossui.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione os produtos IAP que possui"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllIap"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <!-- IAP que não possui | Vigencia Apolice Seguro-->
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.iapNaoPossui.required"
                    >*</small
                  >
                  Produtos IAP que não possui:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectIapNaoPossui"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.iapNaoPossui.value"
                    :options="form.iapNaoPossui.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione os produtos IAP que não possui"
                  >
                    <template v-slot:no-options>{{
                      $lang.Common.PlaceholderSelect
                    }}</template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllIapNaoPossui"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <label> Data Vigência Apólice Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialApoliceSeguro.value"
                  :required="form.dataInicialApoliceSeguro.required"
                  :state="form.dataInicialApoliceSeguro.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data Vigência Apólice Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalApoliceSeguro.value"
                  :required="form.dataFinalApoliceSeguro.required"
                  :state="form.dataFinalApoliceSeguro.state"
                />
              </div>
            </div>
            <hr />
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterCredito === true
                    ? (showFilterCredito = false)
                    : (showFilterCredito = true)
                "
              >
                <i
                  v-if="showFilterCredito"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Crédito</label
              >
              <i
                v-if="hasCreditoFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterCredito">
            <!-- margem contribuição | período margem contribuição -->
            <div class="form-group row">
              <div class="col-md-4">
                <div>
                  <label> Valor Margem de Contribuição Bruta:</label>
                  <div class="input-group">
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="margemContribuicaoInicial"
                      v-bind="$lang.Currency.Format"
                    ></money>
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="margemContribuicaoFinal"
                      v-bind="$lang.Currency.Format"
                    ></money>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <label> Período Margem Contribuição Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialMargemContribuicao.value"
                  :required="form.dataInicialMargemContribuicao.required"
                  :state="form.dataInicialMargemContribuicao.state"
                />
              </div>
              <div class="col-md-3">
                <label> Período Margem Contribuição Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalMargemContribuicao.value"
                  :required="form.dataFinalMargemContribuicao.required"
                  :state="form.dataFinalMargemContribuicao.state"
                />
              </div>
            </div>
            <!-- risco CRL -->
            <div class="form-group row">
              <div class="col-md-4">
                <div>
                  <label> Nível Limite Risco CRL:</label>
                  <div class="input-group">
                    <v-select
                      multiple
                      ref="selectRiscoLimiteCRL"
                      :closeOnSelect="false"
                      :clearSearchOnSelect="false"
                      v-model="form.riscoLimiteCRL.value"
                      :options="form.riscoLimiteCRL.options"
                      :reduce="(x) => x.value"
                      class="w-100"
                      label="text"
                      placeholder="Selecione o Nível do Risco CRL"
                    >
                      <template #list-header>
                        <button
                          class="btn btn-secondary btn-sm btn-block"
                          @click.prevent="handleSelectAllRiscoLimiteCRL"
                        >
                          Selecionar todos
                        </button>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label> Modalidade Produto:</label>
                  <div class="input-group">
                    <v-select
                      multiple
                      ref="selectModalidadeProduto"
                      :closeOnSelect="false"
                      :clearSearchOnSelect="false"
                      v-model="form.modalidadeProduto.value"
                      :options="form.modalidadeProduto.options"
                      :reduce="(x) => x.value"
                      class="w-100"
                      label="text"
                      placeholder="Selecione a Modalidade Produto"
                    >
                      <template #list-header>
                        <button
                          class="btn btn-secondary btn-sm btn-block"
                          @click.prevent="handleSelectAllModalidadeProduto"
                        >
                          Selecionar todos
                        </button>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label> Submodalidade Bacen:</label>
                  <div class="input-group">
                    <v-select
                      multiple
                      ref="selectSubmodalidadeBacen"
                      :closeOnSelect="false"
                      :clearSearchOnSelect="false"
                      v-model="form.submodalidadeBacen.value"
                      :options="form.submodalidadeBacen.options"
                      :reduce="(x) => x.value"
                      class="w-100"
                      label="text"
                      placeholder="Selecione a Submodalidade Bacen"
                    >
                      <template #list-header>
                        <button
                          class="btn btn-secondary btn-sm btn-block"
                          @click.prevent="handleSelectAllSubmodalidadeBacen"
                        >
                          Selecionar todos
                        </button>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
            <!-- data vencimento contrato | data vigencia apolice seguro -->
            <div class="form-group row pt-2">
              <div class="col-md-3">
                <label> Data Vencimento Op. de crédito Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialVencimentoContrato.value"
                  :required="form.dataInicialVencimentoContrato.required"
                  :state="form.dataInicialVencimentoContrato.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data Vencimento Op. de crédito Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalVencimentoContrato.value"
                  :required="form.dataFinalVencimentoContrato.required"
                  :state="form.dataFinalVencimentoContrato.state"
                />
              </div>

              <div class="col-md-3">
                <label> Data Vencimento Pagamento Parcela Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialVencimentoPagamentoParcela.value"
                  :required="
                    form.dataInicialVencimentoPagamentoParcela.required
                  "
                  :state="form.dataInicialVencimentoPagamentoParcela.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data Vencimento Pagamento Parcela Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalVencimentoPagamentoParcela.value"
                  :required="form.dataFinalVencimentoPagamentoParcela.required"
                  :state="form.dataFinalVencimentoPagamentoParcela.state"
                />
              </div>
            </div>

            <div class="form-group row pt-2">
              <NxInputNumberRange
                label="Dias em atraso:"
                @update:InitialValue="
                  handleInputUpdate('diasAtrasoInicio', $event)
                "
                @update:FinalValue="
                  handleInputUpdate('diasAtrasoFinal', $event)
                "
              />
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterMovimentacaoConta === true
                    ? (showFilterMovimentacaoConta = false)
                    : (showFilterMovimentacaoConta = true)
                "
              >
                <i
                  v-if="showFilterMovimentacaoConta"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Movimentação da Conta</label
              >
              <i
                v-if="hasMovimentacaoContaFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterMovimentacaoConta">
            <!-- classificação de Lançamento | periodo classificação de Lançamento -->
            <div class="form-group row">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.classificacaoLancamentoMovimentacao.required"
                    >*</small
                  >
                  Classificação de Lançamento:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectClassificacaoLancamentoMovimentacao"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.classificacaoLancamentoMovimentacao.value"
                    :options="form.classificacaoLancamentoMovimentacao.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione a classificação de lançamento"
                  >
                    <template v-slot:no-options>
                      {{ $lang.Common.PlaceholderSelect }}
                    </template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="
                          handleSelectAllClassificacaoLancamentoMovimentacao
                        "
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>

              <div class="col-md-3">
                <label> Período Lançamento Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialMovimentacaoDiaria.value"
                  :required="form.dataInicialMovimentacaoDiaria.required"
                  :state="form.dataInicialMovimentacaoDiaria.state"
                />
              </div>
              <div class="col-md-3">
                <label> Período Lançamento Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalMovimentacaoDiaria.value"
                  :required="form.dataFinalMovimentacaoDiaria.required"
                  :state="form.dataFinalMovimentacaoDiaria.state"
                />
              </div>
            </div>
            <!-- Valor de Lançamento -->
            <div class="form-group row">
              <div class="col-md-4">
                <div>
                  <label> Valor de lançamento:</label>
                  <div class="input-group">
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="valorLancamentoInicial"
                      v-bind="$lang.Currency.Format"
                    ></money>
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="valorLancamentoFinal"
                      v-bind="$lang.Currency.Format"
                    ></money>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterCartaoCredito === true
                    ? (showFilterCartaoCredito = false)
                    : (showFilterCartaoCredito = true)
                "
              >
                <i
                  v-if="showFilterCartaoCredito"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Cartão de Crédito</label
              >
              <i
                v-if="hasCartaoCreditoFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterCartaoCredito">
            <!-- Limite Atribuido cartao credito | Limite Disponivel cartao credito -->
            <div class="form-groups row">
              <div class="col-md-4">
                <div>
                  <label> Limite Atribuído:</label>
                  <div class="input-group">
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="limiteAtribuidoInicial"
                      v-bind="$lang.Currency.Format"
                    ></money>
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="limiteAtribuidoFinal"
                      v-bind="$lang.Currency.Format"
                    ></money>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div>
                  <label> Limite Disponível:</label>
                  <div class="input-group">
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="limiteDisponivelInicial"
                      v-bind="$lang.Currency.Format"
                    ></money>
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="limiteDisponivelFinal"
                      v-bind="$lang.Currency.Format"
                    ></money>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-3">
              <label
                style="
                  font-size: medium;
                  font-weight: 600;
                  letter-spacing: 0.3px;
                  color: #2e6e60;
                  cursor: pointer;
                "
                @click.prevent="
                  showFilterInvestimentos === true
                    ? (showFilterInvestimentos = false)
                    : (showFilterInvestimentos = true)
                "
              >
                <i
                  v-if="showFilterInvestimentos"
                  class="fas fa-caret-down"
                ></i>
                <i
                  v-else
                  class="fas fa-caret-right"
                ></i>
                Investimentos</label
              >
              <i
                v-if="hasInvestimentosFilter"
                class="fas fa-check pl-2"
                style="color: #2e6e60"
              ></i>
            </div>
          </div>
          <div v-if="showFilterInvestimentos">
            <div class="form-group row">
              <div class="col-md-4">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.modalidadeCaptacao.required"
                    >*</small
                  >
                  Modalidade Captação:
                </label>
                <div class="input-group">
                  <v-select
                    multiple
                    ref="selectModalidadeCaptacao"
                    :closeOnSelect="false"
                    :clearSearchOnSelect="false"
                    v-model="form.modalidadeCaptacao.value"
                    :options="form.modalidadeCaptacao.options"
                    :reduce="(x) => x.value"
                    class="w-100"
                    label="text"
                    placeholder="Selecione a modalidade de Captacao"
                  >
                    <template v-slot:no-options>
                      {{ $lang.Common.PlaceholderSelect }}
                    </template>
                    <template #list-header>
                      <button
                        class="btn btn-secondary btn-sm btn-block"
                        @click.prevent="handleSelectAllModalidadeAplicacao"
                      >
                        Selecionar todos
                      </button>
                    </template>
                  </v-select>
                </div>
              </div>

              <div class="col-md-4">
                <div>
                  <label> Faixa Saldo Diario:</label>
                  <div class="input-group">
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="valorSaldoDiarioInicial"
                      v-bind="$lang.Currency.Format"
                    ></money>
                    <money
                      placeholder="$lang.Currency.Placeholder"
                      class="form-control text-bold"
                      max-length="12"
                      v-model.lazy="valorSaldoDiarioFinal"
                      v-bind="$lang.Currency.Format"
                    ></money>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-3">
                <label> Data Vencimento Aplicação Inicial:</label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialVencimentoAplicacao.value"
                  :required="form.dataInicialVencimentoAplicacao.required"
                  :state="form.dataInicialVencimentoAplicacao.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data Vencimento Aplicação Final:</label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalVencimentoAplicacao.value"
                  :required="form.dataFinalVencimentoAplicacao.required"
                  :state="form.dataFinalVencimentoAplicacao.state"
                />
              </div>

              <div class="col-md-3">
                <label> Data Aplicação Inicial: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataInicialAplicacao.value"
                  :required="form.dataInicialAplicacao.required"
                  :state="form.dataInicialAplicacao.state"
                />
              </div>
              <div class="col-md-3">
                <label> Data Aplicação Final: </label>
                <NxDatePicker
                  :placeholder="$lang.Common.DatePlaceholder"
                  v-model="form.dataFinalAplicacao.value"
                  :required="form.dataFinalAplicacao.required"
                  :state="form.dataFinalAplicacao.state"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row pt-3 pb-3">
          <div class="col-md-12">
            <button
              type="button"
              class="btn btn-third btn-sm"
              v-b-tooltip.hover
              :title="'Pesquisar'"
              @click.prevent="onSearch"
              :disabled="isButtonDisabled()"
            >
              <i class="fas fa-search"></i>
              <span class="d-md-down-none"> Pesquisar</span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-sm text-secundary"
              v-on:click="onClear"
              v-b-tooltip.hover
              :title="$lang.Common.Tooltip.ButtonClear"
            >
              <i class="fa fa-minus-circle"></i>
              <span class="d-md-down-none">
                {{ $lang.Common.Buttons.Clear }}</span
              >
            </button>
          </div>
        </div>

        <FilterKpi ref="FilterKpi" />

        <Tables
          ref="tableGridAdv"
          :columns="['SISBR', 'CPF/CNPJ', 'Nome', 'E-mail', 'Celular']"
          :showTipFooter="false"
          :showHeader="true"
          v-on:Load="onSearch"
        >
          <tr
            v-for="(obj, index) in this.objList"
            v-bind:key="index"
          >
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.numSisbr.toString()"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.document"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.name ? obj.name.toUpperCase() : ''"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.email"
            />
            <TableColumn
              :IsText="true"
              :status="1"
              :value="obj.telefone"
            />
          </tr>
        </Tables>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Adicionar'"
            @click="onCreate"
          >
            <i class="fas fa-check-circle"></i>
            <span class="d-md-down-none"> Adicionar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import PRODUCTS from '@/enums/iapProducts.js'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import DailyAccountMovementRepository from '@/shared/http/repositories/business/dailyaccountmovement.js'
import ClusterRepository from '@/shared/http/repositories/configurations/cluster.js'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee.js'
import ListaContatoRepository from '@/shared/http/repositories/configurations/listacontato.js'
import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente'
import PARepository from '@/shared/http/repositories/configurations/pa.js'
import RegionalRepository from '@/shared/http/repositories/configurations/regional.js'
import CaptacaoRemuneradaDiariaRepository from '../../shared/http/repositories/business/captacaoremuneradadiaria.js'
import ContratosVigentesRepository from '../../shared/http/repositories/business/contratosvigentes'
import RiscoRepository from '../../shared/http/repositories/business/risco.js'

import FilterKpi from '@/views/private/configurations/lista-inteligente/components/add/component/FilterKpi.vue'

import NxDatePicker from '@/components/forms/NxDatePicker.vue'
import { NxInputNumberRange } from '@/components/nexum/components/custom-inputs/index.js'

const AdvancedContactData = {
  tipoPessoa: null,
  document: null,
  numSisbr: null,
  nomeAssociado: null,
  numeroPA: null,
  gerenteSisbrId: null,
  gerenteRelacionamentoId: null,
  clusterizacaoId: null,
  regionalId: null,
  riscoLimiteCRL: null,
  modalidadeProduto: null,
  submodalidadeBacen: null,
  pendencias: null,
  naoPossuiPendencias: null,
  statusContaCorrente: null,
  statusContaCapital: null,
  rendaInicial: null,
  rendaFinal: null,
  dataInicialInicioRelacionamento: null,
  dataFinalInicioRelacionamento: null,
  dataInicialUltimaRenovacao: null,
  dataFinalUltimaRenovacao: null,
  dataInicioNascimentoOuAbertura: null,
  dataFinalNascimentoOuAbertura: null,
  sexo: null,
  estado: null,
  vinculoEmpregaticio: null,
  descricaoProfissao: null,
  tipoRenda: null,
  isFuncionario: null,
  mei: null,
  produtorRural: null,
  iapPossui: null,
  iapNaoPossui: null,
  margemContribuicaoInicial: null,
  margemContribuicaoFinal: null,
  dataInicialMargemContribuicao: null,
  dataFinalMargemContribuicao: null,
  classificacaoLancamentoMovimentacao: null,
  dataInicialMovimentacaoDiaria: null,
  dataFinalMovimentacaoDiaria: null,
  valorLancamentoInicial: null,
  valorLancamentoFinal: null,
  dataInicialVencimentoContrato: null,
  dataFinalVencimentoContrato: null,
  dataInicialApoliceSeguro: null,
  dataFinalApoliceSeguro: null,
  limiteAtribuidoInicial: null,
  limiteAtribuidoFinal: null,
  limiteDisponivelInicial: null,
  limiteDisponivelFinal: null,
  hasAssociadoFilter: null,
  hasProdutoFilter: null,
  hasCreditoFilter: null,
  hasMovimentacaoContaFilter: false,
  hasCartaoCreditoFilter: false,
  diasAtrasoInicio: null,
  diasAtrasoFinal: null,
  dataInicialVencimentoPagamentoParcela: null,
  dataFinalVencimentoPagamentoParcela: null,
  hasInvestimentosFilter: false,
  modalidadeCaptacao: null,
  valorSaldoDiarioInicial: null,
  valorSaldoDiarioFinal: null,
  dataInicialVencimentoAplicacao: null,
  dataFinalVencimentoAplicacao: null,
  dataInicialAplicacao: null,
  dataFinalAplicacao: null
}

const AdvancedContactForm = {
  tipoPessoa: {
    value: null,
    options: [
      { text: 'Pessoa Física', value: 'PF' },
      { text: 'Pessoa Jurídica', value: 'PJ' }
    ],
    required: false,
    state: null
  },
  document: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  numSisbr: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  nomeAssociado: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  numeroPA: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  gerenteSisbrId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  gerenteRelacionamentoId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  clusterizacaoId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  regionalId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  riscoLimiteCRL: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  modalidadeProduto: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  submodalidadeBacen: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  pendencias: {
    value: null,
    options: [
      { text: 'Ajuizado', value: 'AJUIZADO' },
      { text: 'Cobrança', value: 'COBRANCA' },
      { text: 'Impeditiva Absoluta', value: 'IMPEDITIVA_ABSOLUTA' },
      { text: 'Protestado', value: 'PROTESTADO' }
    ],
    required: false,
    state: null
  },
  naoPossuiPendencias: {
    value: null,
    options: [
      { text: 'Ajuizado', value: 'AJUIZADO' },
      { text: 'Cobrança', value: 'COBRANCA' },
      { text: 'Impeditiva Absoluta', value: 'IMPEDITIVA_ABSOLUTA' },
      { text: 'Protestado', value: 'PROTESTADO' }
    ],
    required: false,
    state: null
  },
  statusContaCorrente: {
    value: null,
    options: [
      { text: 'Ativa', value: 'ATIVA' },
      { text: 'Ativa Bloqueada', value: 'ATIVA BLOQUEADA' },
      {
        text: 'Ativa Bloqueada Judicialmente',
        value: 'ATIVA BLOQUEADA JUDICIALMENTE'
      },
      { text: 'Inativa', value: 'INATIVA' },
      { text: 'Inativa Bloqueada', value: 'INATIVA BLOQUEADA' },
      {
        text: 'Inativa Bloqueada Judicialmente',
        value: 'INATIVA BLOQUEADA JUDICIALMENTE'
      },
      { text: 'Não Informado', value: 'NAO INFORMADO' }
    ],
    required: false,
    state: null
  },
  statusContaCapital: {
    value: null,
    options: [
      { text: 'Ativo', value: 'ATIVO' },
      { text: 'Demitido', value: 'DEMITIDO' },
      { text: 'Eliminado', value: 'ELIMINADO' },
      { text: 'Excluído', value: 'EXCLUÍDO' }
    ],
    required: false,
    state: null
  },
  dataInicialInicioRelacionamento: {
    value: '',
    required: false,
    state: null
  },
  dataFinalInicioRelacionamento: {
    value: '',
    required: false,
    state: null
  },
  dataInicialUltimaRenovacao: {
    value: '',
    required: false,
    state: null
  },
  dataFinalUltimaRenovacao: {
    value: '',
    required: false,
    state: null
  },
  dataInicioNascimentoOuAbertura: {
    value: '',
    required: false,
    state: null
  },
  dataFinalNascimentoOuAbertura: {
    value: '',
    required: false,
    state: null
  },
  sexo: {
    value: null,
    options: [
      { text: 'Feminino', value: 'F' },
      { text: 'Masculino', value: 'M' }
    ],
    required: false,
    state: null
  },
  estado: {
    value: null,
    options: [
      { value: 'AC', text: 'Acre' },
      { value: 'AL', text: 'Alagoas' },
      { value: 'AP', text: 'Amapá' },
      { value: 'AM', text: 'Amazonas' },
      { value: 'BA', text: 'Bahia' },
      { value: 'CE', text: 'Ceará' },
      { value: 'DF', text: 'Distrito Federal' },
      { value: 'ES', text: 'Espírito Santo' },
      { value: 'GO', text: 'Goiás' },
      { value: 'MA', text: 'Maranhão' },
      { value: 'MT', text: 'Mato Grosso' },
      { value: 'MS', text: 'Mato Grosso do Sul' },
      { value: 'MG', text: 'Minas Gerais' },
      { value: 'PA', text: 'Pará' },
      { value: 'PB', text: 'Paraíba' },
      { value: 'PR', text: 'Paraná' },
      { value: 'PE', text: 'Pernambuco' },
      { value: 'PI', text: 'Piauí' },
      { value: 'RJ', text: 'Rio de Janeiro' },
      { value: 'RN', text: 'Rio Grande do Norte' },
      { value: 'RS', text: 'Rio Grande do Sul' },
      { value: 'RO', text: 'Rondônia' },
      { value: 'RR', text: 'Roraima' },
      { value: 'SC', text: 'Santa Catarina' },
      { value: 'SP', text: 'São Paulo' },
      { value: 'SE', text: 'Sergipe' },
      { value: 'TO', text: 'Tocantins' }
    ],
    required: false,
    state: null
  },
  vinculoEmpregaticio: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  descricaoProfissao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  tipoRenda: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  isFuncionario: {
    value: null,
    options: [
      { text: 'SIM', value: 'FUNCIONARIO' },
      { text: 'NÃO', value: 'NAO_FUNCIONARIO' }
    ],
    required: false,
    state: null
  },
  mei: {
    value: null,
    required: false,
    state: null
  },
  produtorRural: {
    value: null,
    required: false,
    state: null
  },
  iapPossui: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  iapNaoPossui: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  dataInicialMargemContribuicao: {
    value: '',
    required: false,
    state: null
  },
  dataFinalMargemContribuicao: {
    value: '',
    required: false,
    state: null
  },
  classificacaoLancamentoMovimentacao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  dataInicialMovimentacaoDiaria: {
    value: '',
    required: false,
    state: null
  },
  dataFinalMovimentacaoDiaria: {
    value: '',
    required: false,
    state: null
  },
  dataInicialVencimentoContrato: {
    value: '',
    required: false,
    state: null
  },
  dataFinalVencimentoContrato: {
    value: '',
    required: false,
    state: null
  },
  dataInicialApoliceSeguro: {
    value: '',
    required: false,
    state: null
  },
  dataFinalApoliceSeguro: {
    value: '',
    required: false,
    state: null
  },
  diasAtrasoInicio: {
    value: null,
    required: false,
    state: null
  },
  diasAtrasoFinal: {
    value: null,
    required: false,
    state: null
  },
  dataInicialVencimentoPagamentoParcela: {
    value: '',
    required: false,
    state: null
  },
  dataFinalVencimentoPagamentoParcela: {
    value: '',
    required: false,
    state: null
  },
  modalidadeCaptacao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  dataInicialVencimentoAplicacao: {
    value: '',
    required: false,
    state: null
  },
  dataFinalVencimentoAplicacao: {
    value: '',
    required: false,
    state: null
  },
  dataInicialAplicacao: {
    value: '',
    required: false,
    state: null
  },
  dataFinalAplicacao: {
    value: '',
    required: false,
    state: null
  }
}

export default {
  name: 'ModalListaContatoAdvancedSearch',
  mixins: [ActionsForm],
  data () {
    return {
      data: AdvancedContactData,
      form: AdvancedContactForm,
      rendaInicial: 0,
      rendaFinal: 0,
      listaInteligenteId: null,
      filters: null,
      selected: [],
      selectAll: false,
      persons: [],
      advancedSearch: false,
      margemContribuicaoInicial: 0,
      margemContribuicaoFinal: 0,
      valorLancamentoInicial: 0,
      valorLancamentoFinal: 0,
      limiteAtribuidoInicial: 0,
      limiteAtribuidoFinal: 0,
      limiteDisponivelInicial: 0,
      limiteDisponivelFinal: 0,
      valorSaldoDiarioInicial: 0,
      valorSaldoDiarioFinal: 0,
      showFilterAssociado: false,
      showFilterProduto: false,
      showFilterCredito: false,
      showFilterMovimentacaoConta: false,
      showFilterCartaoCredito: false,
      showFilterOperacoesCredito: false,
      showFilterInvestimentos: false,
      hasAssociadoFilter: false,
      hasProdutoFilter: false,
      hasCreditoFilter: false,
      hasMovimentacaoContaFilter: false,
      hasCartaoCreditoFilter: false,
      hasInvestimentosFilter: false
    }
  },
  components: {
    NxDatePicker,
    FilterKpi,
    NxInputNumberRange
  },
  methods: {
    onLoad () {
      this.onClear()
    },
    onLoadAllEmployees () {
      EmployeeRepository.GetAll()
        .then((response) => {
          const funcionariosOptionList = response.data.content
            .filter((x) => x.usuarioId != null)
            .map((x) => ({ value: x.id, text: x.pessoa.nome }))

          this.form.gerenteSisbrId.options = funcionariosOptionList
          this.form.gerenteRelacionamentoId.options = funcionariosOptionList
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllPAs () {
      PARepository.GetAll()
        .then((response) => {
          this.form.numeroPA.options = response.data.content.map((x) => ({
            value: x.numero,
            text: x.descricao
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllCluster () {
      ClusterRepository.GetAll()
        .then((response) => {
          this.form.clusterizacaoId.options = response.data.content.map(
            (x) => ({ value: x.id, text: x.descricao })
          )
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllRegional () {
      RegionalRepository.GetAll()
        .then((response) => {
          this.form.regionalId.options = response.data.content.map((x) => ({
            value: x.id,
            text: x.nome
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllRiscoCRL () {
      RiscoRepository.GetNivelRiscoCRL()
        .then((response) => {
          this.form.riscoLimiteCRL.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllModalidadeProduto () {
      ContratosVigentesRepository.GetModalidadeProduto()
        .then((response) => {
          this.form.modalidadeProduto.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllSubmodalidadeBacen () {
      ContratosVigentesRepository.GetSubmodalidadeBacen()
        .then((response) => {
          this.form.submodalidadeBacen.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllTipoRenda () {
      AssociateRepository.GetAllTipoRenda()
        .then((response) => {
          this.form.tipoRenda.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllDescricaoProfissao () {
      AssociateRepository.GetAllDescricaoProfissao()
        .then((response) => {
          this.form.descricaoProfissao.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllVinculoEmpregaticio () {
      AssociateRepository.GetAllVinculoEmpregaticio()
        .then((response) => {
          this.form.vinculoEmpregaticio.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllClassificacaoLancamento () {
      DailyAccountMovementRepository.GetAllClassificacaoLancamento()
        .then((response) => {
          this.form.classificacaoLancamentoMovimentacao.options =
            response.data.map((x) => ({ value: x, text: x }))
        })
        .catch((err) => this.onException(err))
    },
    onLoadAllProductsIap () {
      let productsIap = []
      let count = 0
      for (const key in PRODUCTS) {
        productsIap[count] = { text: PRODUCTS[key], value: key }
        count++
      }

      this.form.iapPossui.options = productsIap
      this.form.iapNaoPossui.options = productsIap
    },
    onLoadAllModalidadeCaptacao () {
      CaptacaoRemuneradaDiariaRepository.GetModalidadeCaptacao()
        .then((response) => {
          this.form.modalidadeCaptacao.options = response.data.map((x) => ({
            value: x,
            text: x
          }))
        })
        .catch((err) => this.onException(err))
    },
    onClear () {
      this.onReset()
    },
    showModal (listaInteligenteId) {
      this.$refs['modal-advanced-contact'].show()

      this.$nextTick(() => {
        this.onReset()
        this.onLoadAllEmployees()
        this.onLoadAllPAs()
        this.onLoadAllCluster()
        this.onLoadAllRegional()
        this.onLoadAllTipoRenda()
        this.onLoadAllRiscoCRL()
        this.onLoadAllModalidadeProduto()
        this.onLoadAllSubmodalidadeBacen()
        this.onLoadAllDescricaoProfissao()
        this.onLoadAllVinculoEmpregaticio()
        this.onLoadAllClassificacaoLancamento()
        this.onLoadAllProductsIap()
        this.onLoadAllModalidadeCaptacao()
        this.listaInteligenteId = listaInteligenteId
        loading.push()
        ListaInteligenteRepository.FindListaInteligenteFilter(
          this.listaInteligenteId
        )
          .then((response) => {
            if (response.status === 200) {
              Tools.SetValueInForm(this.form, this.data, response.data)
              this.hasAssociadoFilter = this.data.hasAssociadoFilter
              this.hasProdutoFilter = this.data.hasProdutoFilter
              this.hasCreditoFilter = this.data.hasCreditoFilter
              this.hasMovimentacaoContaFilter =
                this.data.hasMovimentacaoContaFilter
              this.hasCartaoCreditoFilter = this.data.hasCartaoCreditoFilter
              this.hasInvestimentosFilter = this.data.hasInvestimentosFilter

              if (
                this.data.hasAssociadoFilter ||
                this.data.hasProdutoFilter ||
                this.data.hasCreditoFilter ||
                this.data.hasMovimentacaoContaFilter ||
                this.data.hasCartaoCreditoFilter ||
                this.data.hasInvestimentosFilter
              ) {
                this.advancedSearch = true
              }
            }
            loading.pop()
          })
          .catch(this.onException)
      })
    },
    hideModal () {
      this.onReset()
      this.$refs['modal-advanced-contact'].hide()
      this.$emit('created')
    },
    onReset () {
      Tools.ClearDataForms(this.form, this.data)
      this.persons = []
      this.selected = []
      this.selectAll = false
      this.objList = []
      this.rendaInicial = 0
      this.rendaFinal = 0
      this.margemContribuicaoInicial = 0
      this.margemContribuicaoFinal = 0
      this.limiteAtribuidoInicial = 0
      this.limiteAtribuidoFinal = 0
      this.limiteDisponivelInicial = 0
      this.limiteDisponivelFinal = 0
      this.valorSaldoDiarioInicial = 0
      this.valorSaldoDiarioFinal = 0
      this.$refs.tableGridAdv && this.$refs.tableGridAdv.Clear()

      if (this.$refs.FilterKpi) this.$refs.FilterKpi.clearData()
    },
    onSearch () {
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        loading.push()

        if (this.data.document) {
          let document = this.data.document
            .replaceAll('-', '')
            .replaceAll('.', '')
            .replaceAll('/', '')
          this.data.document = document
        }

        if (this.rendaInicial && this.rendaInicial > 0) {
          this.data.rendaInicial = this.rendaInicial
        }
        if (this.rendaFinal && this.rendaFinal > 0) {
          this.data.rendaFinal = this.rendaFinal
        }
        if (
          this.margemContribuicaoInicial &&
          this.margemContribuicaoInicial > 0
        ) {
          this.data.margemContribuicaoInicial = this.margemContribuicaoInicial
        }
        if (this.margemContribuicaoFinal && this.margemContribuicaoFinal > 0) {
          this.data.margemContribuicaoFinal = this.margemContribuicaoFinal
        }
        if (this.valorLancamentoInicial && this.valorLancamentoInicial > 0) {
          this.data.valorLancamentoInicial = this.valorLancamentoInicial
        }
        if (this.valorLancamentoFinal && this.valorLancamentoFinal > 0) {
          this.data.valorLancamentoFinal = this.valorLancamentoFinal
        }
        if (this.limiteAtribuidoInicial && this.limiteAtribuidoInicial > 0) {
          this.data.limiteAtribuidoInicial = this.limiteAtribuidoInicial
        }
        if (this.limiteAtribuidoFinal && this.limiteAtribuidoFinal > 0) {
          this.data.limiteAtribuidoFinal = this.limiteAtribuidoFinal
        }
        if (this.limiteDisponivelInicial && this.limiteDisponivelInicial > 0) {
          this.data.limiteDisponivelInicial = this.limiteDisponivelInicial
        }
        if (this.limiteDisponivelFinal && this.limiteDisponivelFinal > 0) {
          this.data.limiteDisponivelFinal = this.limiteDisponivelFinal
        }
        if (this.valorSaldoDiarioInicial && this.valorSaldoDiarioInicial > 0) {
          this.data.valorSaldoDiarioInicial = this.valorSaldoDiarioInicial
        }
        if (this.valorSaldoDiarioInicial && this.valorSaldoDiarioFinal > 0) {
          this.data.valorSaldoDiarioFinal = this.valorSaldoDiarioFinal
        }
        let filters = Tools.getFilters(this.data)

        AssociateRepository.SearchCampanhaLista(
          filters,
          this.$refs.tableGridAdv.pagingLimit,
          this.$refs.tableGridAdv.pagingIndex
        )
          .then((response) => {
            this.onResultGrid(this.gridData(response), this.$refs.tableGridAdv)
            this.$refs.FilterKpi.loadCooperadosAtingidos(
              this.$refs.tableGridAdv.total
            )
          })
          .catch(this.onException)
      }
    },
    select () {
      if (!this.selectAll) {
        for (let i in this.objList) {
          this.selected.push(this.objList[i])
        }
      }
    },
    onCreate () {
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        loading.push()

        if (this.data.document) {
          let document = this.data.document
            .replaceAll('-', '')
            .replaceAll('.', '')
            .replaceAll('/', '')
          this.data.document = document
        }

        if (this.rendaInicial && this.rendaInicial > 0) {
          this.data.rendaInicial = this.rendaInicial
        }
        if (this.rendaFinal && this.rendaFinal > 0) {
          this.data.rendaFinal = this.rendaFinal
        }
        if (
          this.margemContribuicaoInicial &&
          this.margemContribuicaoInicial > 0
        ) {
          this.data.margemContribuicaoInicial = this.margemContribuicaoInicial
        }
        if (this.margemContribuicaoFinal && this.margemContribuicaoFinal > 0) {
          this.data.margemContribuicaoFinal = this.margemContribuicaoFinal
        }
        if (this.valorLancamentoInicial && this.valorLancamentoInicial > 0) {
          this.data.valorLancamentoInicial = this.valorLancamentoInicial
        }
        if (this.valorLancamentoFinal && this.valorLancamentoFinal > 0) {
          this.data.valorLancamentoFinal = this.valorLancamentoFinal
        }
        if (this.limiteAtribuidoInicial && this.limiteAtribuidoInicial > 0) {
          this.data.limiteAtribuidoInicial = this.limiteAtribuidoInicial
        }
        if (this.limiteAtribuidoFinal && this.limiteAtribuidoFinal > 0) {
          this.data.limiteAtribuidoFinal = this.limiteAtribuidoFinal
        }
        if (this.limiteDisponivelInicial && this.limiteDisponivelInicial > 0) {
          this.data.limiteDisponivelInicial = this.limiteDisponivelInicial
        }
        if (this.limiteDisponivelFinal && this.limiteDisponivelFinal > 0) {
          this.data.limiteDisponivelFinal = this.limiteDisponivelFinal
        }
        if (this.valorSaldoDiarioInicial && this.valorSaldoDiarioInicial > 0) {
          this.data.valorSaldoDiarioInicial = this.valorSaldoDiarioInicial
        }
        if (this.valorSaldoDiarioFinal && this.valorSaldoDiarioFinal > 0) {
          this.data.valorSaldoDiarioFinal = this.valorSaldoDiarioFinal
        }

        const associadoFields = [
          'dataInicioNascimentoOuAbertura',
          'dataFinalNascimentoOuAbertura',
          'dataInicialInicioRelacionamento',
          'dataFinalInicioRelacionamento',
          'dataInicialUltimaRenovacao',
          'dataFinalUltimaRenovacao',
          'tipoPessoa',
          'sexo',
          'estado',
          'pendencias',
          'naoPossuiPendencias',
          'vinculoEmpregaticio',
          'descricaoProfissao',
          'tipoRenda',
          'isFuncionario',
          'mei',
          'produtorRural'
        ]
        const produtoFields = [
          'statusContaCorrente',
          'statusContaCapital',
          'iapPossui',
          'iapNaoPossui',
          'dataInicialApoliceSeguro',
          'dataFinalApoliceSeguro'
        ]
        const creditoFields = [
          'dataInicialMargemContribuicao',
          'dataFinalMargemContribuicao',
          'riscoLimiteCRL',
          'modalidadeProduto',
          'submodalidadeBacen',
          'dataInicialVencimentoContrato',
          'dataFinalVencimentoContrato',
          'diasAtrasoInicio',
          'diasAtrasoFinal',
          'dataInicialVencimentoPagamentoParcela',
          'dataFinalVencimentoPagamentoParcela'
        ]
        const movimentacaoContaFields = [
          'classificacaoLancamentoMovimentacao',
          'dataInicialMovimentacaoDiaria',
          'dataFinalMovimentacaoDiaria'
        ]
        const investimentosFields = [
          'modalidadeCaptacao',
          'dataInicialVencimentoAplicacao',
          'dataFinalVencimentoAplicacao',
          'dataInicialAplicacao',
          'dataFinalAplicacao'
        ]

        for (let key of associadoFields) {
          if (this.form[key].value || this.rendaInicial || this.rendaFinal) {
            if (this.form[key].value && this.form[key].value.length !== 0) {
              this.hasAssociadoFilter = true
              break
            }
          } else {
            this.hasAssociadoFilter = false
          }
        }
        for (let key of produtoFields) {
          if (this.form[key].value) {
            if (this.form[key].value.length !== 0) {
              this.hasProdutoFilter = true
              break
            }
          } else {
            this.hasProdutoFilter = false
          }
        }
        for (let key of creditoFields) {
          if (
            this.form[key].value ||
            this.margemContribuicaoFinal ||
            this.valorLancamentoFinal
          ) {
            if (this.form[key].value.length !== 0) {
              this.hasCreditoFilter = true
              break
            }
          } else {
            this.hasCreditoFilter = false
          }
        }
        for (let key of movimentacaoContaFields) {
          if (
            this.form[key].value ||
            this.margemContribuicaoInicial ||
            this.valorLancamentoInicial
          ) {
            if (this.form[key].value.length !== 0) {
              this.hasMovimentacaoContaFilter = true
              break
            }
          } else {
            this.hasMovimentacaoContaFilter = false
          }
        }
        for (let key of investimentosFields) {
          if (
            this.form[key].value ||
            this.valorSaldoDiarioInicial ||
            this.valorSaldoDiarioFinal
          ) {
            if (this.form[key].value.length !== 0) {
              this.hasInvestimentosFilter = true
              break
            }
          } else {
            this.hasInvestimentosFilter = false
          }
        }

        this.hasCartaoCreditoFilter = !!(
          this.limiteAtribuidoInicial ||
          this.limiteAtribuidoFinal ||
          this.limiteDisponivelInicial ||
          this.limiteDisponivelFinal
        )

        this.data.hasAssociadoFilter = this.hasAssociadoFilter
        this.data.hasProdutoFilter = this.hasProdutoFilter
        this.data.hasCreditoFilter = this.hasCreditoFilter
        this.data.hasMovimentacaoContaFilter = this.hasMovimentacaoContaFilter
        this.data.hasCartaoCreditoFilter = this.hasCartaoCreditoFilter
        this.data.hasInvestimentosFilter = this.hasInvestimentosFilter
        ListaContatoRepository.ImportWithFilterListaInteligente(
          this.listaInteligenteId,
          this.data
        )
          .then((response) => {
            if (response.status === 201 || response.status === 200) {
              loading.pop()
              this.hideModal()
              toast.success(this.$lang.Common.Alerts.Success)
            }
          })
          .catch(this.onException)
      }
    },
    gridData (response) {
      if (
        response.data &&
        response.data.content &&
        response.data.content.length > 0
      ) {
        response.data.content = response.data.content.flatMap((item) => {
          const pessoa = item.pessoa || {}
          const telefones = pessoa.telefone || []

          const celulares = telefones.filter(
            (contato) => contato.tipoContato === 'CELULAR'
          )

          if (celulares.length > 0) {
            return celulares.map((celular) => ({
              numSisbr: item.numSisbr || '',
              document: pessoa.document || '',
              name: pessoa.nome || '',
              email: pessoa.email || '',
              telefone: celular.telefone || ''
            }))
          } else {
            return [
              {
                numSisbr: item.numSisbr || '',
                document: pessoa.document || '',
                name: pessoa.nome || '',
                email: pessoa.email || '',
                telefone: ''
              }
            ]
          }
        })
      } else {
        response.data.content = []
      }

      return response
    },
    toggleAdvancedSearch () {
      this.advancedSearch = !this.advancedSearch
    },
    isButtonDisabled () {
      const formFields = [
        'nomeAssociado',
        'document',
        'numSisbr',
        'numeroPA',
        'regionalId',
        'clusterizacaoId',
        'gerenteSisbrId',
        'gerenteRelacionamentoId',
        'dataInicioNascimentoOuAbertura',
        'dataFinalNascimentoOuAbertura',
        'dataInicialInicioRelacionamento',
        'dataFinalInicioRelacionamento',
        'dataInicialUltimaRenovacao',
        'dataFinalUltimaRenovacao',
        'tipoPessoa',
        'sexo',
        'estado',
        'pendencias',
        'naoPossuiPendencias',
        'vinculoEmpregaticio',
        'descricaoProfissao',
        'tipoRenda',
        'isFuncionario',
        'mei',
        'produtorRural',
        'statusContaCorrente',
        'statusContaCapital',
        'iapPossui',
        'iapNaoPossui',
        'dataInicialApoliceSeguro',
        'dataFinalApoliceSeguro',
        'dataInicialMargemContribuicao',
        'dataFinalMargemContribuicao',
        'riscoLimiteCRL',
        'modalidadeProduto',
        'submodalidadeBacen',
        'classificacaoLancamentoMovimentacao',
        'dataInicialMovimentacaoDiaria',
        'dataFinalMovimentacaoDiaria',
        'dataInicialVencimentoContrato',
        'dataFinalVencimentoContrato',
        'diasAtrasoInicio',
        'diasAtrasoFinal',
        'dataInicialVencimentoPagamentoParcela',
        'dataFinalVencimentoPagamentoParcela',
        'modalidadeCaptacao',
        'dataInicialVencimentoAplicacao',
        'dataFinalVencimentoAplicacao',
        'dataInicialAplicacao',
        'dataFinalAplicacao'
      ]

      return !formFields.some((field) => this.form[field].value)
    },
    handleSelectAll (fieldName, refName) {
      const select = this.$refs[refName]
      const visibleOptions = select.filteredOptions.map(
        (option) => option.value
      )
      this.form[fieldName].value = visibleOptions
    },
    handleSelectAllPA () {
      this.handleSelectAll('numeroPA', 'selectPA')
    },
    handleSelectAllRegional () {
      this.handleSelectAll('regionalId', 'selectRegional')
    },
    handleSelectAllCluster () {
      this.handleSelectAll('clusterizacaoId', 'selectCluster')
    },
    handleSelectAllGerenteSisbr () {
      this.handleSelectAll('gerenteSisbrId', 'selectGerenteSisbr')
    },
    handleSelectAllGerenteRelacionamento () {
      this.handleSelectAll(
        'gerenteRelacionamentoId',
        'selectGerenteRelacionamento'
      )
    },
    handleSelectAllEstado () {
      this.handleSelectAll('estado', 'selectEstado')
    },
    handleSelectAllPendencias () {
      this.handleSelectAll('pendencias', 'selectPendencias')
    },
    handleSelectAllnaoPossuiPendencias () {
      this.handleSelectAll('naoPossuiPendencias', 'selectnaoPossuiPendencias')
    },
    handleSelectAllVinculoEmpregaticio () {
      this.handleSelectAll('vinculoEmpregaticio', 'selectVinculoEmpregaticio')
    },
    handleSelectAllDescricaoProfissao () {
      this.handleSelectAll('descricaoProfissao', 'selectDescricaoProfissao')
    },
    handleSelectAllTipoRenda () {
      this.handleSelectAll('tipoRenda', 'selectTipoRenda')
    },
    handleSelectAllContaCorrente () {
      this.handleSelectAll('statusContaCorrente', 'selectStatusContaCorrente')
    },
    handleSelectAllRiscoLimiteCRL () {
      this.handleSelectAll('riscoLimiteCRL', 'selectRiscoLimiteCRL')
    },
    handleSelectAllIap () {
      this.handleSelectAll('iapPossui', 'selectIap')
    },
    handleSelectAllIapNaoPossui () {
      this.handleSelectAll('iapNaoPossui', 'selectIapNaoPossui')
    },
    handleSelectAllClassificacaoLancamentoMovimentacao () {
      this.handleSelectAll(
        'classificacaoLancamentoMovimentacao',
        'selectClassificacaoLancamentoMovimentacao'
      )
    },
    handleSelectAllModalidadeProduto () {
      this.handleSelectAll('modalidadeProduto', 'selectModalidadeProduto')
    },
    handleSelectAllSubmodalidadeBacen () {
      this.handleSelectAll('submodalidadeBacen', 'selectSubmodalidadeBacen')
    },
    handleSelectAllModalidadeAplicacao () {
      this.handleSelectAll('modalidadeCaptacao', 'selectModalidadeCaptacao')
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName].value = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    clearField (field) {
      this.form[field].value = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/ModalListaContatoAdvancedSearch.vue